import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { YesNo } from 'models/Fields';
import { CREATE_LISTING_OPTIONS } from 'models/DealRoom';
import { ListingType } from 'models/Listing';
import { LISTING_TYPE_ROUTES } from 'router/subrouters/ListingCreationWizard/utils';
import PencilaltIcon from 'icons/Pencilalt.icon';
import PluscircleIcon from 'icons/Pluscircle.icon';
import ClockIcon from 'icons/Clock.icon';
import SparklesIcon from 'icons/Sparkles.icon';

// Form field holding the listing type the AI should draft against. Sent to BE as
// `type` - on publishDeal when creating, on triggerImExtraction when editing.
export const LISTING_TYPE_FLOW = 'listingTypeFlow';

export default function useDraftListingOptions() {
  const { t } = useTranslation();

  const createListingOptions = useMemo(
    () => [
      {
        label: (
          <>
            <PluscircleIcon />
            {t('draftListing')}
          </>
        ),
        value: CREATE_LISTING_OPTIONS.DRAFT_LISTING,
      },
      {
        label: (
          <>
            <ClockIcon />
            {t('setUpDealRoom')}
          </>
        ),
        value: CREATE_LISTING_OPTIONS.SET_DEAL_ROOM,
      },
    ],
    [t],
  );

  const draftListingOptions = useMemo(
    () => [
      {
        value: YesNo.Yes,
        label: (
          <>
            <SparklesIcon className="sparkles" />
            <span>
              {t('yesUseDocument')} <p>{t('weWillDraftListing')}</p>
            </span>
          </>
        ),
      },
      {
        value: YesNo.No,
        label: (
          <>
            <PencilaltIcon />
            <span>
              {t('noWillDoItMyself')} <p>{t('useLCW')}</p>
            </span>
          </>
        ),
      },
    ],
    [t],
  );

  const listingTypeOptions = useMemo(
    () =>
      Object.entries(LISTING_TYPE_ROUTES).map(
        ([value, { label, icon: Icon }]) => ({
          value: value as ListingType,
          label: (
            <>
              <Icon />
              {t(label)}
            </>
          ),
        }),
      ),
    [t],
  );

  return { createListingOptions, draftListingOptions, listingTypeOptions };
}
